import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-background-50 px-4 text-center">
      <h1 className="text-6xl md:text-8xl font-heading text-primary-500">404</h1>
      <p className="mt-4 text-lg text-foreground-700">This page could not be found.</p>
      <p className="mt-2 text-sm text-foreground-500">The page you are looking for might have been moved or does not exist.</p>
      <Link
        to="/"
        className="mt-8 inline-flex items-center gap-2 px-6 py-3 rounded-full text-sm font-semibold bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
      >
        Back to Homepage
      </Link>
    </div>
  );
}